<template>
  <b-card>
    <b-form-group
        label="เปอร์เซ็นจ่ายแคชแบค *"
        label-for="cashbackCommissionRate"
    >
      <ValidationProvider
          v-slot="{ errors }"
          name="cashbackCommissionRate"
          rules="required"
      >
        <b-input-group append="%">
          <b-input
              id="cashbackCommissionRate"
              v-model="form.cashbackCommissionRate"
              :state="errors[0] ? false : null"
          ></b-input>
        </b-input-group>
      </ValidationProvider>
    </b-form-group>
    <b-form-group
        label="แคชแบคที่แจกสูงสุดต่อวัน (ต่อยูส) *"
        label-for="cashbackQuotaPerDay"
    >
      <ValidationProvider
          v-slot="{ errors }"
          name="cashbackQuotaPerDay"
          rules="required"
      >
        <b-input
            id="cashbackQuotaPerDay"
            v-model="form.cashbackQuotaPerDay"
            :state="errors[0] ? false : null"
        ></b-input>
      </ValidationProvider>
    </b-form-group>
    <b-form-group
        label="ถอนขั้นต่ำ (บาท) *"
        label-for="minWithdrawCashback"
    >
      <ValidationProvider
          v-slot="{ errors }"
          name="minWithdrawCashback"
          rules="required"
      >
        <b-input
            id="minWithdrawCashback"
            v-model="form.minWithdrawCashback"
            :state="errors[0] ? false : null"
        ></b-input>
      </ValidationProvider>
    </b-form-group>

    <b-form-group
        label="ถอนสูงสุดต่อวัน (จำนวนครั้ง) *"
        label-for="maxWithdrawCashbackTimePerDay"
    >
      <ValidationProvider
          v-slot="{ errors }"
          name="maxWithdrawCashbackTimePerDay"
          rules="required"
      >
        <b-input
            id="maxWithdrawCashbackTimePerDay"
            v-model="form.maxWithdrawCashbackTimePerDay"
            :state="errors[0] ? false : null"
        ></b-input>
      </ValidationProvider>
    </b-form-group>

    <template v-if="!isLA">
      <b-form-group
          label="ถอนสูงสุดต่อวัน (จำนวนยอดเงินคืน) *"
          label-for="maxWithdrawCashbackAmountPerDay"
      >
        <ValidationProvider
            v-slot="{ errors }"
            name="maxWithdrawCashbackAmountPerDay"
            rules="required"
        >
          <b-input
              id="maxWithdrawCashbackAmountPerDay"
              v-model="form.maxWithdrawCashbackAmountPerDay"
              :state="errors[0] ? false : null"
          ></b-input>
        </ValidationProvider>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox
            id="canDirectWithdrawCashback"
            v-model="form.canDirectWithdrawCashback"
            switch
        >
          ถอนเงินคืนตรงเข้าบัญชีธนาคาร
        </b-form-checkbox>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox
            id="turnEnabled"
            v-model="form.cashbackTurnConfig.isActive"
            switch
        >
          ถอนเงินคืนแบบติดเทิร์น
        </b-form-checkbox>
      </b-form-group>

      <b-form-group
          v-if="form.cashbackTurnConfig.isActive"
          :label="$t('cashback.turnover_point')"
      >
        <b-row class="mb-3">
          <b-col>
            <b-input-group prepend="ประเภทเทิร์น">
              <b-select
                  id="turnType"
                  v-model="form.cashbackTurnConfig.turnType"
              >
                <b-form-select-option
                    v-for="(opt, key) in turnTypeOptions"
                    :key="key"
                    :value="opt.value"
                >
                  {{ opt.text }}
                </b-form-select-option>
              </b-select>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row v-if="form.cashbackTurnConfig.turnType !== 2">
          <b-col>
            <ValidationProvider
                v-slot="{ errors }"
                name="ยอดเทิร์น"
                rules="required|min:1"
            >
              <b-input-group append="เท่า" prepend="ยอดเทิร์น">
                <b-input
                    v-model="form.cashbackTurnConfig.turnRate"
                    :state="errors[0] ? false : null"
                    type="number"
                ></b-input>
              </b-input-group>
            </ValidationProvider>
            <b-form-text>
              ระบบจะนำยอดฝากกับโบนัสเอาไปคูณ เช่นเทิร์น 10 เท่า ฝาก 100
              โบนัส 50 ลูกค้าต้องทำเทิร์น 1500
            </b-form-text>
          </b-col>
          <b-col>
            <b-input-group>
              <b-input-group-prepend is-text>
                <b-form-checkbox
                    v-model="haveMaxWithdraw"
                    name="haveMaxWithdraw"
                    switch
                >
                </b-form-checkbox>
              </b-input-group-prepend>

              <b-input-group-prepend is-text>
                อั้นถอน
              </b-input-group-prepend>

              <b-input
                  v-model="form.cashbackTurnConfig.maxWithdraw"
                  :disabled="!haveMaxWithdraw"
                  type="number"
              ></b-input>

              <template #append>
                <b-form-select
                    id="maxWithdrawType"
                    v-model="form.cashbackTurnConfig.maxWithdrawType"
                    :disabled="!haveMaxWithdraw"
                    style="width: 80px; min-width: 80px"
                >
                  <b-form-select-option :value="0">เครดิต</b-form-select-option>
                  <b-form-select-option :value="1">เท่า</b-form-select-option>
                </b-form-select>
              </template>
            </b-input-group>
          </b-col>
        </b-row>
      </b-form-group>
    </template>

    <b-form-group>
      <b-form-checkbox
          id="isEnableCashbackTime"
          v-model="form.isEnableCashbackTime"
          switch
      >
        การจ่ายเงินคืนแบบกำหนดเวลา
      </b-form-checkbox>
    </b-form-group>
    <b-form-group>
      <template v-if="form.isEnableCashbackTime">
        <b-row
            v-for="day in daysInWeek"
            :key="day.en"
        >
          <b-col class="d-flex">
            <b-form-checkbox
                v-model="form.cashbackTime[day.en].isEnable"
                switch
            />
            <b class="mx-2">{{ day.th }}</b>
          </b-col>
          <b-col>
            <ValidationProvider
                v-slot="{ errors }"
                :name="`cashbackTime.${day.en}.startTime`"
                :rules="{required: true, regex:/^([01][0-9]|2[0-4]):([0-5][0-9])$/}"
            >
              <b-input
                  v-model="form.cashbackTime[day.en].startTime"
                  :disabled="!form.cashbackTime[day.en].isEnable"
                  :state="errors[0] ? false : null"
              />
              <b-form-text>ตัวอย่าง: 00:00</b-form-text>
            </ValidationProvider>
          </b-col>
          <b-col>
            <ValidationProvider
                v-slot="{ errors }"
                :name="`cashbackTime.${day.en}.endTime`"
                :rules="{required: true, regex:/^([01][0-9]|2[0-4]):([0-5][0-9])$/}"
            >
              <b-input
                  v-model="form.cashbackTime[day.en].endTime"
                  :disabled="!form.cashbackTime[day.en].isEnable"
                  :state="errors[0] ? false : null"
              />
              <b-form-text>ตัวอย่าง: 24:00</b-form-text>
            </ValidationProvider>
          </b-col>
        </b-row>
      </template>
    </b-form-group>
  </b-card>
</template>

<script>
export default {
  page: {
    title: 'ตั้งค่าเอเย่นต์ | ระบบเงินคืน (แคชแบค)',
  },
  props: {
    agentData: {
      type: Object,
      default: () => ({
        cashbackCommissionRate: 0,
        cashbackQuotaPerDay: 0,
        minWithdrawCashback: 0,
        maxWithdrawCashbackTimePerDay: 0,
        maxWithdrawCashbackAmountPerDay: 0,
        canDirectWithdrawCashback: false,
        isEnableCashbackTime: false,
        cashbackTurnConfig: {
          isActive: false,
          turnType: 0,
          turnRate: 0,
          haveMaxWithdraw: false,
          maxWithdrawType: 0,
          maxWithdraw: 0,
        },
        cashbackTime: {
          sunday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
          monday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
          tuesday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
          wednesday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
          thursday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
          friday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
          saturday: { isEnable: false, startTime: '00:00', endTime: '24:00' },
        },
      }),
    },
  },
  data() {
    return {
      turnTypeOptions: [
        { text: 'เทิร์นเครดิต', value: 0 },
        { text: 'เทิร์นโอเวอร์', value: 1 },
        { text: 'ไม่มีเทิร์น', value: 2 },
      ],
      haveMaxWithdraw: false,
      form: {},
    }
  },
  computed: {
    isLA() {
      return process.env.VUE_APP_IS_LA === 'true'
    },
    daysInWeek() {
      return [
        { en: 'sunday', th: 'วันอาทิตย์' },
        { en: 'monday', th: 'วันจันทร์' },
        { en: 'tuesday', th: 'วันอังคาร' },
        { en: 'wednesday', th: 'วันพุธ' },
        { en: 'thursday', th: 'วันพฤหัสบดี' },
        { en: 'friday', th: 'วันศุกร์' },
        { en: 'saturday', th: 'วันเสาร์' },
      ]
    },
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('update', val)
      },
      deep: true
    }
  },
  created() {
    this.form = {
      cashbackCommissionRate: this.agentData.cashbackCommissionRate,
      cashbackQuotaPerDay: this.agentData.cashbackQuotaPerDay,
      minWithdrawCashback: this.agentData.minWithdrawCashback,
      maxWithdrawCashbackTimePerDay: this.agentData.maxWithdrawCashbackTimePerDay,
      maxWithdrawCashbackAmountPerDay: this.agentData.maxWithdrawCashbackAmountPerDay,
      canDirectWithdrawCashback: this.agentData.canDirectWithdrawCashback,
      isEnableCashbackTime: this.agentData.isEnableCashbackTime,
      cashbackTime: this.agentData.cashbackTime,
      cashbackTurnConfig: this.agentData.cashbackTurnConfig,
    }
    if (this.isLA) {
      this.form.maxWithdrawCashbackAmountPerDay = 0
      this.form.cashbackTurnConfig = {
        isActive: false,
        turnType: 0,
        turnRate: 0,
        haveMaxWithdraw: this.agentData.cashbackTurnConfig.haveMaxWithdraw || false,
        maxWithdrawType: this.agentData.cashbackTurnConfig.maxWithdrawType || 0,
        maxWithdraw: this.agentData.cashbackTurnConfig.maxWithdraw || 0,
      }
    } else {
      this.haveMaxWithdraw = Number(this.agentData.cashbackTurnConfig?.maxWithdraw || 0) > 0
    }
  },
}
</script>

<style></style>
